<template>
  <div class="soon-overlay" @click.self="close">
    <section
      class="soon-dialog"
      role="dialog"
      aria-modal="true"
      aria-labelledby="soon-title"
    >
      <button
        class="soon-close"
        type="button"
        aria-label="Close"
        @click="close"
      >
        &times;
      </button>

      <div class="soon-icon" aria-hidden="true">
        <svg
          width="46"
          height="46"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="24"
            cy="24"
            r="17"
            stroke="currentColor"
            stroke-width="2.5"
          />
          <path
            d="M24 13V24L31 29"
            stroke="currentColor"
            stroke-width="2.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>

      <h2 id="soon-title" class="soon-title">COMING SOON</h2>

      <p class="soon-desc">Selling skins is not available yet.</p>
    </section>
  </div>
</template>

<script>
export default {
  name: 'ComingSoonModal',

  methods: {
    close() {
      this.$emit('close')
    },
  },
}
</script>

<style scoped>
.soon-overlay {
  position: fixed;
  inset: 0;
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(4, 5, 8, 0.86);
  backdrop-filter: blur(5px);
}

.soon-dialog {
  position: relative;
  width: 100%;
  max-width: 450px;
  overflow: hidden;
  padding: 52px 30px 0;
  border: 1px solid #444752;
  border-radius: 8px;
  background: linear-gradient(145deg, #25272e, #0c0d10);
  box-shadow: 0 25px 70px rgba(0, 0, 0, 0.6);
  color: #fff;
  text-align: center;
}

.soon-close {
  position: absolute;
  right: 18px;
  top: 13px;
  padding: 0;
  background: none;
  border: 0;
  color: #a8abb4;
  font-size: 30px;
  line-height: 1;
  cursor: pointer;
}

.soon-close:hover {
  color: #fff;
}

.soon-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 86px;
  height: 86px;
  margin: 0 auto 25px;
  border: 1px solid rgba(234, 189, 10, 0.4);
  border-radius: 12px;
  background: rgba(234, 189, 10, 0.08);
  color: #eabd0a;
}

.soon-kicker {
  margin-bottom: 10px;
  font:
    700 11px/1.5 'Roboto',
    sans-serif;
  letter-spacing: 3px;
  color: #eabd0a;
}

.soon-title {
  margin: 0 0 18px;
  font:
    700 36px/1.2 'Montserrat',
    sans-serif;
  color: #fff;
}

.soon-desc {
  margin: 0 auto 28px;
  font:
    400 16px/1.6 'Roboto',
    sans-serif;
  color: #c9cbd2;
}

.soon-action {
  width: 100%;
  max-width: 200px;
  padding: 14px 22px;
  border: 0;
  border-radius: 6px;
  background: #eabd0a;
  color: #0c0d10;
  font:
    700 14px/20px 'Roboto',
    sans-serif;
  cursor: pointer;
  transition: opacity 0.2s;
}

.soon-action:hover {
  opacity: 0.8;
}

.soon-foot {
  margin: 38px -30px 0;
  padding: 16px;
  background: rgba(0, 0, 0, 0.18);
  border-top: 1px solid #353741;
  color: #a1a3ab;
  font:
    700 10px/1.5 'Roboto',
    sans-serif;
  letter-spacing: 1.5px;
}

.soon-dot {
  display: inline-block;
  width: 6px;
  height: 6px;
  margin-right: 7px;
  border-radius: 50%;
  background: #eabd0a;
  vertical-align: middle;
}

@media (max-width: 480px) {
  .soon-dialog {
    padding: 44px 20px 0;
  }

  .soon-title {
    font-size: 29px;
  }

  .soon-foot {
    margin-left: -20px;
    margin-right: -20px;
  }
}
</style>
